<template lang="pug">
v-app
  v-layout.center-container
    v-card.auth-card
      .col-group
        p.auth-title サインイン
      .col-group
        v-form(v-model="signinFormValid")
          v-text-field(
            v-model="email"
            label="メールアドレス"
            color="primary"
            :rules="[rules.required, rules.email]"
          )
          v-text-field(
            v-model="password"
            label="パスワード"
            persistent-hint
            hint="8文字以上で半角英大小文字を含める"
            counter
            length="8"
            type="password"
            :rules="[rules.password]"
            @keyup.enter = "signIn"
          )
      .col-group
        v-btn(
          @click="signIn"
          color="black"
          :disabled="!inputValid"
          style="color: white;"
        ) サインイン
      v-dialog(v-model='dialog', persistent, max-width='600px')
        v-card
          v-card-title
            span.headline 初回パスワード変更
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex(xs12)
                  v-text-field(label='パスワード*', required, v-model='newPassword')
                v-flex(xs12)
                  v-text-field(label='パスワード確認*', required, v-model='newPasswordConfirm')
          v-card-actions
            v-spacer
            v-btn(color='blue darken-1', flat='', @click='closeDialog') Close
            v-btn(color='blue darken-1', flat='', @click='changePassword') Save
</template>
<script>
// util
import API from '@/api/api.js'
import validator from 'validator'
import DisplayDataUtil from '@/utils/DisplayDataUtil'

export default {
  name: 'signin',
  data () {
    return {
      email: '',
      password: '',
      session: '',
      nickname: '',
      newPassword: '',
      newPasswordConfirm: '',
      dialog: false,
      sub: null,
      user: null,
      signinFormValid: false,
      // validation
      rules: DisplayDataUtil.validationRules
    }
  },
  computed: {
    inputValid () {
      return validator.isEmail(this.email) && this.password.length > 0
    },
    checkPassword () {
      return this.newPassword === this.newPasswordConfirm
    }
  },
  methods: {
    signIn () {
      if (!this.signinFormValid) return
      this.$store.dispatch('signIn', { email: this.email, password: this.password }).then(() => {
        // nothing
      }).catch((err) => {
        let data = JSON.parse(err.message)
        this.nickname = data.nickname
        this.email = data.email
        this.session = data.session
        this.dialog = true
      })
    },
    changePassword () {
      API.ChangeAdminUserPassword({ param: { session: this.session, email: this.email, name: this.nickname, password: this.newPassword } }).then(result => {
        this.$store.dispatch('signIn', { email: this.email, password: this.newPassword })
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    closeDialog () {
      this.dialog = false
      this.newPassword = ''
      this.newPasswordConfirm = ''
    }
  },
  created () {
  }
}
</script>
<style lang="stylus" scoped>
.col-group
  display flex
  flex-direction column

.auth-title
  margin 0
  font-size 24px
  display flex
  justify-content center

.auth-card
  width 600px
  height 480px
  display flex
  flex-direction column
  justify-content space-between
  padding 16px 32px
</style>
